/**
 * Bundle Reorganization Script
 * Handles DOM manipulation for product bundles layout
 */

function moveVariantsIntoDetails() {
  // Sélectionne tous les conteneurs de produits
  document.querySelectorAll('.rbu-sb-tier-product-container').forEach(container => {
    const details = container.querySelector('.rbu-sb-tier-product-details');
    const variants = container.querySelector('.rbu-sb-tier-product-variants');

    if (details && variants) {
      // Déplace les variantes à l'intérieur des détails
      details.appendChild(variants);
    }
  });
}

function reorganizeBundle() {
  const mainContainer = document.querySelector('.product-content.anchor');
  const bundleContainer = document.querySelector('.rbu-sb-container');

  if (mainContainer && bundleContainer) {
    const width = mainContainer.offsetWidth;
    bundleContainer.style.width = width + 'px';
    console.log('Largeur assignée à rbu-sb-container :', width, 'px');
  }

  const container = document.querySelector(".rbu-sb-container");
  if (!container) return false;

  // Création des blocs
  const productsBlock = document.createElement("div");
  productsBlock.className = "rbu-sb-products-block";

  const sidebarBlock = document.createElement("div");
  sidebarBlock.className = "rbu-sb-sidebar-block";

  const contentWrapper = document.createElement("div");
  contentWrapper.className = "rbu-sb-content-wrapper";

  // Sélection des éléments à réorganiser
  const productContainers = container.querySelectorAll(".rbu-sb-tier-container");
  const dividers = container.querySelectorAll(".rbu-sb-product-divider");
  const total = container.querySelector(".rbu-sb-totals");
  const addToCart = container.querySelector(".rbu-sb-btn");
  const header = container.querySelector(".rbu-sb-header");

  // Vider le container
  container.innerHTML = "";

  // Réinjection du header tout en haut
  if (header) {
    header.style.width = "100%";
    container.appendChild(header);
  }

  // Réinjection des produits + dividers
  productContainers.forEach((prod, i) => {
    productsBlock.appendChild(prod);
    if (dividers[i]) productsBlock.appendChild(dividers[i]);
  });

  // Sidebar (totaux + bouton)
  if (total) sidebarBlock.appendChild(total);
  if (addToCart) sidebarBlock.appendChild(addToCart);

  // Injecter le wrapper qui contient les deux colonnes
  contentWrapper.appendChild(productsBlock);
  contentWrapper.appendChild(sidebarBlock);
  container.appendChild(contentWrapper);

  // Styles
  container.style.display = "flex";
  container.style.flexDirection = "column"; // le header en haut, puis le contenu
  container.style.gap = "20px";

  contentWrapper.style.display = "flex";
  contentWrapper.style.gap = "20px";
  contentWrapper.style.alignItems = "flex-start";

  productsBlock.style.flex = "2";
  productsBlock.style.display = "flex";
  productsBlock.style.flexDirection = "column";

  sidebarBlock.style.flex = "1";
  sidebarBlock.style.display = "flex";
  sidebarBlock.style.flexDirection = "column";
  sidebarBlock.style.alignSelf = "anchor-center";
  
  moveVariantsIntoDetails();
  return true;
}

// Initialize bundle reorganization
function initBundleReorganization() {
  // Observer le DOM pour détecter l'apparition du bundle
  const observer = new MutationObserver((mutations, obs) => {
    if (reorganizeBundle()) {
      obs.disconnect(); // stop observer une fois exécuté
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBundleReorganization);
} else {
  initBundleReorganization();
}
